import { render, staticRenderFns } from "./SocialMediaMobileLinks.vue?vue&type=template&id=c75ce8c2&scoped=true&"
var script = {}
import style0 from "./SocialMediaMobileLinks.vue?vue&type=style&index=0&id=c75ce8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75ce8c2",
  null
  
)

export default component.exports